import React, { useEffect, useState } from "react";
import Select from "react-select";
import appStyles from "../../../../utils/appStyles";
import strings from "../../../../utils/property-file/scheduleLeave.json";
import "./scheduleEmpLeave.css";
import LeaveCalendar from "../../scheduleLeaveCalendar/leaveCalendar";
import api from "../../../../services/api";
import { toast } from "react-toastify";
import SpinnerButton from "../../../button/spinnerButton";
import PropTypes from "prop-types"

export default function SelectEmpLeave(props) {
  const [employeeData, setEmployeeData] = useState([]);
  const [openCalendarLeave, setOpenCalendarLeave] = useState(false);
  const [selectEmployee, setSelectedEmployee] = useState();
  const [employeeLoading, setEmployeeLoading] = useState(true);

  const employeeName =
    employeeData != null
      ? employeeData
          .map((employee) => {
            if (employee.isActive) {
              return { value: employee._id, label: employee.name };
            }
            return null;
          })
          .filter(Boolean)
      : null;

  const getActiveEmployeeName = async () => {
    try {
      const response = await api.getEmployeeStatus("");
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmployeeData(data.body);
        } else {
          setEmployeeData([]);
        }
        setEmployeeLoading(false);
      }
      setEmployeeLoading(false);
    } catch (error) {
      setEmployeeLoading(false);
      toast.error(strings.somethingWentWrongLabel, { toastId: "error6" });
    }
  };

  useEffect(() => {
    getActiveEmployeeName();
  }, []);

  return (
    <div className="main-container-leave mt-3">
      {employeeLoading ? (
        <div className="employee-loader">
          <SpinnerButton />
        </div>
      ) : (
        <div className="emp-select-container">
          <label htmlFor="" className="select-emp-label">
            {strings.selectEmpLabel}
          </label>
          <Select
            className="emp-name-select-leave"
            options={employeeName}
            styles={appStyles.companyProfileDropdown}
            defaultValue={selectEmployee}
            onChange={(selectEmployee) => {
              setOpenCalendarLeave(true);
              setSelectedEmployee(selectEmployee);
            }}
          />
        </div>
      )}

      <div className="leave-calendar">
        {openCalendarLeave && (
          <div>
            <LeaveCalendar
              selectedEmployeeName={selectEmployee ? selectEmployee : null}
              type={props.type}
            />
          </div>
        )}
      </div>
    </div>
  );
}

SelectEmpLeave.propTypes = {
  type : PropTypes.any.isRequired
}